import React, { useContext } from 'react';
import AuthContext from '../context/AuthProvider';
import { useNavigate } from 'react-router';

function LogoutButton() {
    const { setAuth } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogout = () => {
        setAuth("0");
        localStorage.removeItem("AudioTimeAuth");
        navigate("/giris");
    };

    return (
        <button
            onClick={handleLogout}
            style={{
                marginTop: "12px",
                background: "transparent",
                border: "1px solid rgba(220,50,50,0.6)",
                color: "#fff",
                background: "rgba(180,30,30,0.75)",
                padding: "6px 18px",
                borderRadius: "4px",
                cursor: "pointer",
                fontSize: "13px",
                letterSpacing: "1px",
            }}
        >
            ÇIKIŞ YAP
        </button>
    );
}

export default LogoutButton;